/* eslint-disable */
import { IconButton, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import {
  MdLogout,
  MdMailOutline,
  MdOutlineHome,
  MdOutlineSettings,
} from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import LogoDark from '../../../../../assets/LogoDark.svg';
import {
  BTNLogoutStyled,
  ButtonsContainerStyled,
  ConfigureStyled,
  HeaderContainerStyled,
  IconsContainerStyled,
} from './SAHeader.styles';

export function SAHeader(props) {
  const { iconHome, iconSettings, iconMail } = props;
  const navigate = useNavigate();

  const [configure, setConfigure] = useState(false);

  function logout() {
    localStorage.removeItem('user');
    localStorage.removeItem('token');

    navigate('/admin');
  }
  function handleGoToHome() {
    navigate('/home');
  }
  function handleGoToTermsOfUse() {
    navigate('/terms-of-use');
  }
  function handleGoToPrivacy() {
    navigate('/privacy');
  }

  return (
    <>
      <HeaderContainerStyled
        onClick={() => configure === true && setConfigure(!configure)}
      >
        <img src={LogoDark} alt="logo da sioon" />
        <ButtonsContainerStyled onClick={() => setConfigure(!configure)}>
          <IconsContainerStyled>
            {iconHome && (
              <IconButton onClick={() => handleGoToHome()} size="large">
                <MdOutlineHome color="#FFF" />
              </IconButton>
            )}
            <IconButton size="large">
              <MdMailOutline color="#fff" />
            </IconButton>
            <IconButton
              onClick={() => setConfigure(!configure)}
              style={{
                backgroundColor: iconSettings && '#F2F2F2',
              }}
              size="large"
            >
              <MdOutlineSettings color={iconSettings ? '#4D5275' : '#F2F2F2'} />
            </IconButton>
          </IconsContainerStyled>
          <BTNLogoutStyled onClick={() => logout()} size="large">
            <MdLogout color="#fff" />
            <Typography variant="h4">Sair</Typography>
          </BTNLogoutStyled>
        </ButtonsContainerStyled>
      </HeaderContainerStyled>
      {configure && (
        <ConfigureStyled>
          <Typography variant="h5" color="secondary">
            Configurar sistema
          </Typography>
          <hr />
          <Typography onClick={() => handleGoToPrivacy()}>
            Alterar políticas de privacidade
          </Typography>
          <hr />
          <Typography onClick={() => handleGoToTermsOfUse()}>
            Alterar termos de uso
          </Typography>
        </ConfigureStyled>
      )}
    </>
  );
}

SAHeader.propTypes = {
  iconHome: PropTypes.bool.isRequired,
  iconMain: PropTypes.bool.isRequired,
  iconSettings: PropTypes.bool.isRequired,
};
